<template>
  <div class="navigation-box" :style="{width:toggle ? '80px' : '188px'}">
    <slot/>
  </div>
  <a-button class="navigation-footer" size="large" @click="$emit('update:toggle', !toggle)">
    <template #icon>
      <right-circle-outlined v-if="toggle"/>
      <LeftCircleOutlined v-else/>
    </template>
    <span v-if="!toggle">收起</span>
  </a-button>
</template>

<script setup lang="ts">
import {LeftCircleOutlined, RightCircleOutlined} from "@ant-design/icons-vue";

defineProps<{ toggle: boolean }>()
defineEmits(['update:toggle'])

</script>

<style scoped lang="sass">
.navigation-box
  flex: 1
  overflow-y: auto
  height: 100%
  transition: all .3s

  &::-webkit-scrollbar
    display: none

.navigation-footer
  margin: 18px

</style>